<template>
  <VanPopup
    v-model:show="store.showCharacterAllDialogModal"
    class="h-[80%] overflow-hidden"
    position="bottom"
    round
  >
    <div class="grid grid-rows-[auto_1fr] h-full">
      <div class="mb-4">
        <div class="relative">
          <h1 class="text-base text-center my-4">
            {{ $t("game.audioManager") }}
          </h1>
          <button
            class="btn btn-xs absolute top-0 right-4"
            @click="clickRefresh"
          >
            <i class="iconfont icon-rotate-right text-xs"></i>
          </button>
        </div>
      </div>

      <ThreadList
        ref="promptListRef"
        :enable-pull-load="false"
        :enable-scroll-load="false"
        class="px-2"
      >
        <div
          v-for="dialogId in store.dialogList"
          class="flex items-center gap-1 mb-1"
        >
          <div :key="dialogId" class="flex flex-col items-center">
            <div
              class="border-2 border-[#3f3f3f] flex items-center justify-center w-[50px] aspect-[3/4] rounded"
            >
              <i class="iconfont icon-icon text-xl" />
            </div>
            <div class="flex items-center py-1 px-2 rounded">
              <span class="mr-1">
                {{ $t(`game.role.4`) }}
              </span>
            </div>
          </div>
          <div class="flex-1 border rounded-md p-2.5 flex flex-col">
            <p class="flex-1">
              {{ store.dialogMap[dialogId].text }}
            </p>

            <!-- 管理 -->
            <div class="flex justify-end mt-4 font-light">
              <div class="flex items-center">
                <button
                  :class="[
                    'btn   btn-xs rounded  mr-2 px-1',
                    store.dialogMap[dialogId].isAudioEnabled && 'text-primary',
                  ]"
                  @click="clickEditAudioEnabled(store.dialogMap[dialogId])"
                >
                  <i class="iconfont icon-volume text-xs font-light" />
                </button>
                <button
                  v-if="
                    store.dialogMap[dialogId].text &&
                    store.dialogMap[dialogId].mateToneId
                  "
                  class="btn btn-xs rounded mr-2 px-1"
                  @click="clickReGenerateAudio(store.dialogMap[dialogId])"
                >
                  <i
                    class="iconfont icon-switch text-xs mr-[-3px] font-light"
                  />
                  <span>{{ $t("Buttons.regenerate") }}</span>
                </button>
                <PlayAudio
                  v-if="
                    store.dialogMap[dialogId].audioMedia?.url &&
                    store.showCharacterAllDialogModal
                  "
                  :url="store.dialogMap[dialogId].audioMedia?.url"
                  class="mr-2"
                />
                <div
                  v-else-if="
                    store.dialogMap[dialogId].text &&
                    store.dialogMap[dialogId].mateToneId
                  "
                  class="flex text-xs items-center"
                >
                  {{ $t("game.processing") }}
                  <p class="text-xs loading loading-dots ml-1"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ThreadList>
    </div>
  </VanPopup>
</template>

<script lang="ts" setup>
import ThreadList, {
  ThreadListInstance,
} from "@/components/mobile/ThreadList.vue";
import { showFailToast, showLoadingToast, showSuccessToast } from "vant";
import { ref } from "vue";
import { watch } from "vue";
import { useI18n } from "vue-i18n";
import i18n from "@/locales";
import { useStoryGameEditor } from "@/stores/storyGameEditor";
import { ApiPostStoryGameDialogToneRegenerate } from "@/apis/story-game";

const store = useStoryGameEditor();
const { t } = useI18n();
const promptListRef = ref<ThreadListInstance>();

// 搜索条件

const getName = (id: number) => {
  return (
    store.characterIdMap[id]?.name ||
    t(`game.role.${store.characterIdMap[id].role}`)
  );
};

const clickRefresh = async () => {
  store.dialogList = [];
  const loading = showLoadingToast({
    message: i18n.global.t("Message.loading"),
    duration: 0,
    mask: true,
  });
  await store.initDialog(store.activeNode.id!, true);
  loading.close();
};

// 点击编辑事件
const clickEditAudioEnabled = (dialog: StoryGameDialog) => {
  dialog.isAudioEnabled = !dialog.isAudioEnabled;
  store.saveDialog(dialog);
};
const clickReGenerateAudio = async (dialog: StoryGameDialog) => {
  const loading = showLoadingToast({
    message: i18n.global.t("Message.regeneratingAudio"),
    duration: 0,
    mask: true,
  });

  try {
    if (dialog.audioMedia) dialog.audioMedia.url = "";
    const { item } = await ApiPostStoryGameDialogToneRegenerate(dialog.id!);
    if (dialog.audioMedia) dialog.audioMedia.url = item.audioMedia.url;
    else dialog.audioMedia = item.audioMedia;
    loading.close();
    showSuccessToast(i18n.global.t("Message.regeneratedAudioSuccessfully"));
  } catch (e) {
    console.log(e);
    loading.close();
    showFailToast(i18n.global.t("Message.regeneratedAudioFailed"));
  }
};
</script>
